/**
 * sceneRegistry — defines the SceneId union and the ordered registry of
 * kiosk scenes, mapping id → component + display title. Pure module, no I/O.
 *
 * Monitor-only build: the 'timeline' scene (control-event feed) was removed
 * along with the ActivityTimeline surface. The 'tank-vision' scene was
 * removed with the TankVision page — persisted kiosk settings that still
 * reference it are filtered out on load (never auto-deleted from the Pi).
 */
import type { ComponentType } from 'react';

import { SceneBigNumbers } from './scenes/SceneBigNumbers';
import { SceneSchedule } from './scenes/SceneSchedule';

export type SceneId = 'big-numbers' | 'schedule';

export interface SceneEntry {
  id: SceneId;
  title: string;
  component: ComponentType;
}

/** Canonical ordered registry — the display order in the kiosk rotation. */
export const SCENE_REGISTRY: readonly SceneEntry[] = [
  { id: 'big-numbers', title: 'Big Numbers', component: SceneBigNumbers },
  { id: 'schedule', title: "Today's Schedule", component: SceneSchedule },
];

/** Default scene order when no settings have been saved yet. */
export const DEFAULT_SCENE_IDS: SceneId[] = ['big-numbers', 'schedule'];

/** Look up a scene entry by id. Returns `undefined` if not found. */
export function getSceneEntry(id: SceneId): SceneEntry | undefined {
  return SCENE_REGISTRY.find((s) => s.id === id);
}
